import { createSlice } from "@reduxjs/toolkit";
import { userThemeInstalled } from "./ThunkAction";
import { iThemeState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iThemeState = {
  isLoading: false,
  userThemeList:[],
  errorMessage: null,
};
export const userThemeSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetThemeState: () => {
      return initialState; // Reset to the initial state
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userThemeInstalled.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(userThemeInstalled.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.userThemeList = payload.data.data; 
          state.isLoading = false;
        }
      })
      .addCase(userThemeInstalled.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch data";
        state.isLoading = false;
      });
  },
});

export const { resetThemeState } = userThemeSlice.actions;
export default userThemeSlice.reducer;
